import React from 'react';
import './ComponentCard.css';

const ComponentCard = ({ componentData }) => {
    return (
        <div className="component-card-container">
            <div className="component-card-image">
                {/* Immagine del componente (Placeholder) */}
                <img 
                    src={componentData.imageSrc || 'placeholder-image.jpg'} 
                    alt={componentData.name} 
                />
            </div>
            <div className="component-card-details">
                <h3 className="component-name">{componentData.name}</h3>
                <p className="component-manufacturer">{componentData.manufacturer}</p>
                <p className="component-specs-title">Technical specifications</p>
                <p className="component-specs">{componentData.specs}</p>
                <a href={componentData.link} target="_blank" rel="noopener noreferrer" className="component-link">
                    Link
                </a>
            </div>
        </div>
    );
};

export default ComponentCard;